export default {
  testingMetadata: {
    personalTesting: 'Персональное тестирование',
    commentTitle: 'Дополните свои ответы по данному блоку в свободной форме.',
    commentDescription: 'В результатах оценки будет виден только ваш комментарий без указания ФИО.',
    commentRequiredHint:
      '*Комментарий обязателен к заполнению, без комментария тест нельзя завершить.',
    commentRequiredHintScore: '*Комментарий обязателен к заполнению в зависимости от вашей оценки.',
    descriptionTitle: 'Описание задачи/проекта',
    openQuestionsBlock: 'Открытые вопросы к блоку компетенций',
    currentScore: 'Текущая оценка',
    // buttons
    saveAndNextButton: 'Сохранить и перейти далее',
    saveResultsButton: 'Сохранить и завершить тест',
    createReportSelfButton: 'Сформировать отчёт',
    closeTestingButton: 'Выйти из теста',
    resetAnswersButton: 'Сбросить ответы',
    // confirm dialogs
    confirmResetAnswers: {
      title: 'Сбросить ответы?',
      text: 'Сбросить все ответы прохождения оценки по навыку',
      button: 'Да, сбросить',
    },
    // dialogs
    infoSuccessTest360Dialog: {
      title: 'Тест завершён',
      defaultText: 'Ваши ответы сохранены. Благодарим за уделённое время!',
      hiddenReportText:
        'Результаты опроса будут обсуждаться на индивидуальной встрече с руководителем, как только все опросы будут обработаны.',
    },
    continuePulseTest360Dialog: {
      title: 'Хотите пройти ещё один блок?',
    },
    infoSuccessPulseTest360Dialog: {
      title: 'Вы полностью прошли опрос',
      text: 'Благодарим за уделённое время!',
    },
    testIsNotAvailableDialog: {
      title: 'Тест недоступен',
      finished: 'Ваши оценки по этому сеансу тестирования уже были сохранены.',
      noRole: 'Вы не являетесь участником этой оценки. Обратитесь к организатору оценки.',
      futureStart: 'Время прохождения теста ещё не наступило.',
      expired: 'Период прохождения тестирования истёк, пожалуйста, ожидайте результатов.',
      deleted:
        'Данный тест недоступен, возможно он был удалён, чтобы узнать подробности, обратитесь к вашему организатору оценки.',
      closed: 'Оценка была закрыта организатором.',
    },
    completedDialog: {
      title: 'Тестирование завершено',
      text: 'Ваши ответы сохранены.</br>Благодарим за уделённое время!',
    },
    timeIsOutDialog: {
      title: 'Время на тестирование истекло',
      text: 'Ваши ответы будут сохранены.',
    },
    restoredSessionDialog: {
      text: 'Восстановлен прерванный сеанс тестирования',
    },
    incorrectSessionDialog: {
      title: 'Обнаружена существующая активная сессия',
      text: 'Вы уже начали тест в другой вкладке или на другом устройстве.\nЧтобы продолжить тест, вернитесь к уже открытой вкладке или нажмите кнопку "Продолжить здесь" - в этом случае все предыдущие сеансы теста будут закрыты. Тестирование будет продолжено с места остановки',
      button: 'Продолжить здесь',
    },
    // messages
    invalidMessage: {
      openQuestions: 'Заполнены не все обязательные вопросы',
      default: 'Не заполнены обязательные комментарии или вопросы или оценены не все индикаторы',
    },
    successMessages: {
      saveAnswer: 'Черновик сохранён',
      resetAnswers: 'Текущая оценка сброшена',
      saveResults: 'Ваши ответы сохранены',
    },
    errorMessages: {
      getBlock: 'Не удалось получить данные о тестировании',
      getTest: 'Не удалось получить данные о тесте',
      getQuestion: 'Не удалось получить данные о вопросе',
      getOpenQuestions: 'Не удалось получить открытые вопросы',
      saveAnswer: 'Не удалось сохранить черновик',
      resetAnswers: 'Не удалось сбросить текущую оценку',
      saveResult: 'Не удалось сохранить ответ',
      saveResults: 'Не удалось сохранить ответы',
      createReportSelf: 'Не удалось сформировать отчёт',
      invalid: 'Не удалось сохранить ответы. В блоке были неотвеченные вопросы',
      getDescription: 'Не удалось загрузить описание задачи/проекта',
      failStartTest: 'Не удалось запустить сеанс тестирования',
    },
    //
  },
};
